import React from "react";

//import material-UI
import {makeStyles, createStyles, Theme} from "@material-ui/core";
import {Box, Button} from "@material-ui/core";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import {useDispatch} from "react-redux";

//import component
import SearchForm from "./SearchForm";
import {useNavigate} from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    subTitle: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      // padding: "40px 36px 16px",
      padding: "20px 36px",
      fontSize: "26px",
      fontWeight: "bold",
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.custom.main,

      "& h2": {
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: "0",
          left: "-10px",
          width: "6px",
          height: "100%",
          backgroundColor: "red",
          borderRadius: "5px",
        },
      },
    },
    addBtn: {
      color: theme.palette.secondary.main,
    },
  })
);

type listTitleProps = {
  setSearchWord?: (value: string) => void;
  searchDispatcher?: () => void;
  page?: number;
  searchWord?: string;
  subTitle: string;
  buttonTitle?: string;
  endPoint?: string;
  modal?: () => void;
};

const ListTitle = ({
  setSearchWord,
  searchDispatcher,
  page,
  searchWord,
  subTitle,
  buttonTitle,
  endPoint,
  modal,
}: listTitleProps) => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <>
      <Box className={classes.subTitle}>
        <h2>{subTitle}</h2>
        {setSearchWord && searchDispatcher && (
          <SearchForm
            setSearchWord={setSearchWord}
            searchDispatcher={searchDispatcher}
            page={page}
            searchWord={searchWord}
          />
        )}
        {buttonTitle && (
          <Button
            className={classes.addBtn}
            variant="outlined"
            size="large"
            onClick={() => {
              modal ? modal() : navigate(endPoint!);
            }}
            endIcon={<AddToPhotosIcon>send</AddToPhotosIcon>}
          >
            {buttonTitle}
          </Button>
        )}
      </Box>
    </>
  );
};

export default ListTitle;
